"use client";
import { useTranslation } from "react-i18next";

export default function PricingCard({
  plan,
  isLoading,
  onSubscribe,
  allFeatures,
}) {
  const { t } = useTranslation();
  const isPopular = plan.productName.toLowerCase().includes("growth");
  const getCurrencySymbol = () => {
    return plan.currency === "USD" ? "$" : "₹";
  };

  const cycle = String(
    plan.recurrence ?? plan.billingCycle ?? "",
  ).toLowerCase();

  const isYearly =
    cycle === "yearly" ||
    cycle === "annual" ||
    cycle === "annually" ||
    cycle === "year";

  const formatPrice = (value) => {
    if (value === null || value === undefined) return value;

    // If API sends "167400" as a string, convert it
    const n =
      typeof value === "number"
        ? value
        : Number(String(value).replace(/,/g, ""));

    // If it isn't a clean number (e.g. "Custom"), return as-is
    if (!Number.isFinite(n)) return value;

    // Add commas (uses user's locale by default; can be customized if needed)
    return n.toLocaleString();
  };

  return (
    <div
      className={`custom-pricing-card ${isPopular ? "custom-pricing-card-popular" : ""}`}
    >
      {isPopular && (
        <div className="custom-pricing-card-badge">
          {" "}
          {t("pricing.card.mostPopular")}
        </div>
      )}

      <h3 className="custom-pricing-card-name">{plan.productName}</h3>
      <p className="custom-pricing-card-description">{plan.description}</p>

      <div className="custom-pricing-card-price-section">
        <div className="custom-pricing-card-price">
          <span className="custom-pricing-card-currency">
            {getCurrencySymbol()}
          </span>
          <span className="custom-pricing-card-amount">
            {formatPrice(plan.amount)}
          </span>
          <span
            className="custom-pricing-card-currency"
            style={{ marginLeft: "10px" }}
          >
            {isYearly ? t("pricing.card.perYear") : t("pricing.card.perMonth")}
          </span>
        </div>
        {/*<p className="custom-pricing-card-billing-period">per month</p>*/}
      </div>

      <button
        className={`custom-pricing-card-cta ${isPopular ? "custom-pricing-card-cta-primary" : "custom-pricing-card-cta-primary"}`}
        onClick={onSubscribe}
        disabled={isLoading}
      >
        {isLoading
          ? t("pricing.card.loading")
          : plan.productName.includes("Enterprise")
            ? t("pricing.card.contactUs")
            : t("pricing.card.buyPlan")}
      </button>

      <div className="custom-pricing-card-features-list">
        <h4 className="custom-pricing-card-features-title">
          {" "}
          {t("pricing.card.thisIncludes")}
        </h4>
        <ul className="custom-pricing-card-features">
          {plan.featureList &&
            plan.featureList.map((feature, idx) => (
              <li key={idx} className="custom-pricing-card-feature">
                <span className="custom-pricing-card-check">✓</span>
                <span>{feature}</span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
